// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
#subtitle-2 #images-count-title,
#subtitle-2 #images-count-add {
  width: 50%;
  color: var(--ion-text-color);
}
#subtitle-2 #images-count-title {
  font-size: 17px;
  font-weight: 700;
}
#subtitle-2 #images-count-add {
  text-align: right;
}
#subtitle-2 #images-count-add ion-button {
  margin: 0px;
  text-transform: capitalize;
  --padding-start: 0px;
  --padding-end: 24px;
  font-size: 13px;
  font-weight: 500;
}
#subtitle-2 #images-count-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

.simple-header {
  font-size: 14px;
  font-weight: 500;
}

.remove-image-icon {
  margin: 0;
  position: absolute;
  top: 8px;
  right: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 7px 2px black;
  border-radius: 50%;
  color: black;
  width: 24px;
  height: 24px;
}

ion-slides {
  height: 100%;
  height: 160px;
}
ion-slides ion-slide {
  overflow: hidden;
}
ion-slides .swiper-slide {
  background: lightgray;
  border-radius: 16px;
  height: 130px;
}
ion-slides .swiper-slide img {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

#categories-list {
  padding: 0px;
}
#categories-list ion-item {
  cursor: pointer;
  min-height: 56px;
  --background: transparent;
  margin-bottom: 0px;
  border-radius: 0px;
  height: auto;
  box-shadow: none;
  --padding-start: 16px;
  --padding-end: 16px;
}
#categories-list ion-item ion-label {
  position: static !important;
}

boxx-content-divider {
  --boxx-content-divider-margin-bottom: 0;
}

ion-select.available {
  color: var(--ion-color-success);
}
ion-select.paused {
  color: var(--ion-color-warning);
}
ion-select.expired {
  color: var(--ion-color-danger);
}

.error-feedback-wrapper {
  min-height: 18px;
  margin-top: 16px;
}
.error-feedback-wrapper .error-feedback {
  text-align: center;
}

#addOption {
  margin: 15px 0;
}

ion-card-content {
  padding: 10px 0px;
}

ion-thumbnail {
  justify-content: center;
  display: flex;
}
ion-thumbnail img {
  border-radius: 6px;
}

.thumbnail-no-image {
  background: #acc5e3;
  border-radius: 6px;
}
.thumbnail-no-image ion-label {
  font-size: 15px;
  font-weight: bold;
}

ion-modal {
  background: rgba(0, 0, 0, 0.3215686275);
}
ion-modal.bottom-end {
  align-items: flex-end;
  --height: auto;
}
ion-modal.bottom-end .ion-page {
  position: relative;
  display: block;
  contain: content;
}

ion-datetime {
  --background: white;
  color: #a8a2a2 !important;
}`, "",{"version":3,"sources":["webpack://./src/modules/@boxx/store-core/lib/components/coupon-form/coupon-form.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACE;;EAEE,UAAA;EACA,4BAAA;AACJ;AACE;EACE,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AACI;EACE,WAAA;EACA,0BAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACN;AACM;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AACR;;AAgDA;EACE,eAAA;EACA,gBAAA;AA7CF;;AAgDA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AA7CF;;AAgDA;EACE,YAAA;EACA,aAAA;AA7CF;AA+CE;EACE,gBAAA;AA7CJ;AAgDE;EACE,qBAAA;EACA,mBAAA;EACA,aAAA;AA9CJ;AAgDI;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA9CN;;AAmDA;EACE,YAAA;AAhDF;AAiDE;EAEE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAhDJ;AAkDI;EACE,2BAAA;AAhDN;;AAqDA;EACE,uCAAA;AAlDF;;AAsDE;EACE,+BAAA;AAnDJ;AAqDE;EACE,+BAAA;AAnDJ;AAqDE;EACE,8BAAA;AAnDJ;;AAuDA;EACE,gBAAA;EACA,gBAAA;AApDF;AAqDE;EACE,kBAAA;AAnDJ;;AAuDA;EACE,cAAA;AApDF;;AAuDA;EACE,iBAAA;AApDF;;AAuDA;EACE,uBAAA;EACA,aAAA;AApDF;AAsDE;EACE,kBAAA;AApDJ;;AAwDA;EACE,mBAAA;EACA,kBAAA;AArDF;AAuDE;EACE,eAAA;EACA,iBAAA;AArDJ;;AAyDA;EACE,uCAAA;AAtDF;AAuDE;EACE,qBAAA;EACA,cAAA;AArDJ;AAuDI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AArDN;;AA0DA;EACE,mBAAA;EACA,yBAAA;AAvDF","sourcesContent":["#subtitle-2 {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin-top: 20px;\n  margin-bottom: 20px;\n\n  #images-count-title,\n  #images-count-add {\n    width: 50%;\n    color: var(--ion-text-color);\n  }\n  #images-count-title {\n    font-size: 17px;\n    font-weight: 700;\n  }\n\n  #images-count-add {\n    text-align: right;\n    ion-button {\n      margin: 0px;\n      text-transform: capitalize;\n      --padding-start: 0px;\n      --padding-end: 24px;\n      font-size: 13px;\n      font-weight: 500;\n\n      ion-icon {\n        margin-right: 3px;\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n}\n\n// ion-list {\n//   background: transparent;\n//   .gallery-item {\n//     --background: transparent;\n//     --padding-start: 16px;\n//     --padding-end: 16px;\n//   }\n//   ion-card {\n//     margin: 0;\n//     margin-bottom: 2px;\n//     min-height: 180px;\n//     width: 100%;\n//     border-radius: 8px;\n//     z-index: 1;\n\n//     ion-card-content {\n//       div {\n//         margin-top: 32px;\n//         margin-bottom: 48px;\n//         max-height: 180px;\n//         &.image {\n//           width: 100%;\n//           height: 180px;\n//           margin: 0;\n//           padding: 8px;\n//           background-size: contain;\n//           background-position: top;\n//           background-repeat: no-repeat;\n//           text-align: right;\n//         }\n\n//         p {\n//           margin-top: 16px;\n//           margin-bottom: 16px;\n//         }\n//         font-size: 14px;\n//         font-weight: 500;\n//       }\n//     }\n//   }\n// }\n\n\n.simple-header {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.remove-image-icon {\n  margin: 0;\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: #ffffff;\n  box-shadow: 0px 0px 7px 2px black;\n  border-radius: 50%;\n  color: black;\n  width: 24px;\n  height: 24px;\n}\n\nion-slides {\n  height: 100%;\n  height: 160px;\n\n  ion-slide {\n    overflow: hidden;\n  }\n\n  .swiper-slide {\n    background: lightgray;\n    border-radius: 16px;\n    height: 130px;\n\n    img {\n      width: 100%;\n      max-width: 100%;\n      height: 100%;\n      max-height: 100%;\n    }\n  }\n}\n\n#categories-list{\n  padding: 0px;\n  ion-item{\n\n    cursor: pointer;\n    min-height: 56px;\n    --background: transparent;\n    margin-bottom: 0px;\n    border-radius: 0px;\n    height: auto;\n    box-shadow: none;\n    --padding-start: 16px;\n    --padding-end: 16px;\n    \n    ion-label{\n      position: static !important;\n    }\n  } \n}\n\nboxx-content-divider {\n  --boxx-content-divider-margin-bottom: 0;\n}\n\nion-select {\n  &.available {\n    color: var(--ion-color-success);\n  }\n  &.paused {\n    color: var(--ion-color-warning);\n  }\n  &.expired {\n    color: var(--ion-color-danger);\n  }\n}\n\n.error-feedback-wrapper {\n  min-height: 18px;\n  margin-top: 16px;\n  .error-feedback {\n    text-align: center;\n  }\n}\n\n#addOption{\n  margin: 15px 0;\n}\n\nion-card-content{\n  padding: 10px 0px;\n}\n\nion-thumbnail {\n  justify-content: center;\n  display: flex;\n\n  img {\n    border-radius: 6px;\n  }\n}\n\n.thumbnail-no-image{\n  background: #acc5e3;\n  border-radius: 6px;\n\n  ion-label{\n    font-size: 15px;\n    font-weight: bold;\n  }\n}\n\nion-modal {\n  background: #00000052;\n  &.bottom-end {\n    align-items: flex-end;\n    --height: auto;\n\n    .ion-page {\n      position: relative;\n      display: block;\n      contain: content;\n    }\n  }\n}\n\nion-datetime {\n  --background: white;\n  color: #a8a2a2 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
